import Section from './Section';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	fitModelsContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		justifyItems: 'center',
		alignContent: 'center',
		alignItems: 'center',
		marginTop: theme.spacing(10),
	},
	fitModelImageContainer: {
		marginTop: theme.spacing(5),
		marginBottom: theme.spacing(5),
	},
	fitModelImage: {
		maxHeight: '600px',
	},
	fitModelDivider: {
		width: '100%',
	},
}));

const FitModelPhotos = () => {
	const { classes } = useStyles();
	const imageUrls = [
		'https://facilery.s3.us-west-1.amazonaws.com/demo-assets/images/tech-packs/fit-model-photos/fit-model-photos.png',
	];

	const imageComponents = imageUrls.map((imageUrl, index) => {
		return (
			<Box key={index}>
				{index > 0 && <Divider className={classes.fitModelDivider} />}
				<Box className={classes.fitModelImageContainer}>
					<img
						className={classes.fitModelImage}
						src={imageUrl}
						alt=""
					/>
				</Box>
			</Box>
		);
	});

	return (
		<Section header="Fit Model Photos">
			<Box className={classes.fitModelsContainer}>{imageComponents}</Box>
		</Section>
	);
};

export default FitModelPhotos;
